import { render, staticRenderFns } from "./js.vue?vue&type=template&id=0543cc1e&scoped=true"
import script from "./js.vue?vue&type=script&lang=js"
export * from "./js.vue?vue&type=script&lang=js"
import style0 from "./js.vue?vue&type=style&index=0&id=0543cc1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543cc1e",
  null
  
)

export default component.exports